import { defineMessages } from 'react-intl';

export default defineMessages({
  aria_label_send_message: {
    id: 'kustomer.chat.form.input.enter.aria.label.send.message',
    description: 'Aria label for send message button',
    defaultMessage: 'Send message',
  },
});
